import IFieldModel from "@mapmycustomers/shared/types/fieldModel/IFieldModel";

import getFieldModelByEntityType, {
  EntityTypeWithFieldModel,
} from "@app/util/fieldModel/getByEntityType";

import { getFieldEntityType } from "./getFieldEntityType";

export const getFieldByPlatformName = (fieldFilterName: string, fieldModel: IFieldModel) => {
  let field = fieldModel.getByPlatformFilterName(fieldFilterName);

  let fieldEntityType: EntityTypeWithFieldModel | undefined;

  if (!field) {
    fieldEntityType = getFieldEntityType(fieldFilterName);
    if (fieldEntityType) {
      const actualFieldName = fieldFilterName.substring(fieldEntityType.length + 1);
      const fieldFieldModel = getFieldModelByEntityType(fieldEntityType!);
      field = fieldFieldModel.getByPlatformFilterName(actualFieldName);
    }
  }

  return { field, fieldEntityType };
};
